// src/contexts/TourContext.js
import React, { createContext, useContext, useState, useCallback } from 'react';

const TourContext = createContext();

export const useTour = () => {
  const context = useContext(TourContext);
  if (!context) {
    throw new Error('useTour must be used within TourProvider');
  }
  return context;
};

export const TourProvider = ({ children }) => {
  const [tourState, setTourState] = useState({
    isActive: false,
    steps: [],
    currentStep: 0,
  });

  const startTour = useCallback((steps) => {
    setTourState({
      isActive: true,
      steps,
      currentStep: 0,
    });
  }, []);

  const nextStep = useCallback(() => {
    setTourState((prev) => {
      if (prev.currentStep < prev.steps.length - 1) {
        return { ...prev, currentStep: prev.currentStep + 1 };
      }
      return prev;
    });
  }, []);

  const prevStep = useCallback(() => {
    setTourState((prev) => {
      if (prev.currentStep > 0) {
        return { ...prev, currentStep: prev.currentStep - 1 };
      }
      return prev;
    });
  }, []);

  const endTour = useCallback(() => {
    setTourState((prev) => ({
      ...prev,
      isActive: false,
      steps: [],
      currentStep: 0,
    }));
  }, []);

  const skipTour = useCallback(() => {
    setTourState({
      isActive: false,
      steps: [],
      currentStep: 0,
    });
  }, []);

  return (
    <TourContext.Provider
      value={{
        tourState,
        startTour,
        nextStep,
        prevStep,
        endTour,
        skipTour,
      }}
    >
      {children}
    </TourContext.Provider>
  );
};